/**
 * Pricing Breakdown of the trip currently being viewed
 */
import React from "react";

import { CustomerPricingType } from "../../../../../../globals/hooks/utils";
import ActiveRoundTrip from "./ActiveRoundTrip";
import ActiveSingleTripBlock from "./ActiveSingleTrip";
import { CurrencyCodeEnum } from "types";
type ActiveTripPricingBlockProps = {
  pricing: CustomerPricingType;
  currencyCode: CurrencyCodeEnum;
};

function ActiveTripPricingBlock(props: ActiveTripPricingBlockProps) {
  const { pricing, currencyCode } = props;
  const isRoundTrip = !!pricing.returnTripPricing;

  return isRoundTrip ? (
    <ActiveRoundTrip activeTripPricing={pricing} currencyCode={currencyCode} />
  ) : (
    <ActiveSingleTripBlock
      activeTripPricing={pricing}
      currencyCode={currencyCode}
    />
  );
}

export default ActiveTripPricingBlock;
